var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-sign-in"},[_c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title-item"},[_vm._v(_vm._s(_vm.systemName)+" Portal")])]),_c('a-form',{staticClass:"sign-in-form",attrs:{"form":_vm.form},on:{"submit":_vm.submit}},[_c('a-form-item',{attrs:{"colon":false,"label":_vm.$t('user.account')}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'member',
          {
            rules: [
              {
                required: true,
                message: _vm.$t('public.pleaseFill', {
                  content: _vm.$t('user.account')
                })
              }
            ]
          }
        ]),expression:"[\n          'member',\n          {\n            rules: [\n              {\n                required: true,\n                message: $t('public.pleaseFill', {\n                  content: $t('user.account')\n                })\n              }\n            ]\n          }\n        ]"}],attrs:{"placeholder":_vm.$t('user.account')}})],1),_c('a-form-item',{attrs:{"colon":false,"label":`${_vm.$t('user.password')}`}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'password',
          {
            rules: [
              {
                required: true,
                message: _vm.$t('public.pleaseFill', {
                  content: _vm.$t('user.password')
                })
              }
            ]
          }
        ]),expression:"[\n          'password',\n          {\n            rules: [\n              {\n                required: true,\n                message: $t('public.pleaseFill', {\n                  content: $t('user.password')\n                })\n              }\n            ]\n          }\n        ]"}],attrs:{"placeholder":_vm.$t('user.password'),"type":"password"}}),_c('div',{staticStyle:{"position":"absolute","right":"-10px","top":"15px"}},[_c('a-button',{attrs:{"type":"link"},on:{"click":_vm.passwordReset}},[_vm._v("\n          找回密码\n        ")])],1)],1),_c('a-form-item',[_c('a-button',{attrs:{"block":"","type":"primary","html-type":"submit"}},[_vm._v("\n        "+_vm._s(_vm.$t('user.signIn'))+"\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }